module.exports = __webpack_public_path__ + "media/svg/cz-4920f112.svg";